/* eslint-disable max-len */
import { ICONS_ID } from '@bitComponents/unifiedIcons/SvgIconLoader';
import { CQ_ACTION_CODES, CQ_POTS } from '../../../catalogConstants';
import { STRING_KEYS } from '../../common';
import { USER_TYPE } from '../../../bitConstants/constants';

export const localizedStrings = {
  common: {
    everyMainSelection: {
      [STRING_KEYS.process.title]: '',
      [STRING_KEYS.se.risk.subject]: 'TELCOBI Equipamiento Riesgo Error 800',
      [STRING_KEYS.se.order.subject]: 'TELCOBI Equipamiento Error TELCO',
      [STRING_KEYS.summary.staticDirectDebit]: 'En tu factura Movistar.',
      [STRING_KEYS.summary.cart.pocDuration]: 'Permanencia {duration} meses',
      [STRING_KEYS.deviceSummaryCart.hguWithoutCost]: 'Router Smart WiFi 6',
      [STRING_KEYS.stepTitles.afterSaleParentProductSelector]: 'Dirección de instalación',
      [STRING_KEYS.afterSaleParentProductInfoBar.icon]: ICONS_ID.Envio,
      [STRING_KEYS.afterSaleParentProductInfoBar.text[CQ_POTS.INSTALLATION_POT.AUTO_INSTALLATION_ID]]: 'Indica en que dirección vas a instalar el equipo, También será la dirección de envío',
      [STRING_KEYS.afterSaleParentProductInfoBar.text[CQ_POTS.INSTALLATION_POT.INSTALLATION_BY_CLIENT]]: 'Indica en que dirección vas a instalar el equipo, También será la dirección de envío',
      [STRING_KEYS.afterSaleParentProductInfoBar.text[CQ_POTS.INSTALLATION_POT.INSTALLATION_ID]]: 'Indica en que dirección vas a instalar el equipo',
      [STRING_KEYS.deviceInstallation.infoBarData1.infoText]: '',
      [STRING_KEYS.summary.shipment.title]: 'Dirección de envío',
      [STRING_KEYS.summary.shipment.text]: 'Entrega en Madrid y Barcelona: 48h. Resto de península, Baleares y Canarias: 72h. Excepto festivos.',
      [STRING_KEYS.summary.shipment.secondaryText]: '',
      [STRING_KEYS.summary.installation.title]: 'Dirección de instalación',
      [STRING_KEYS.confirmation.subtitle]: 'Puedes hacer seguimiento del pedido en tu área privada.',
      [STRING_KEYS.shipment.text]: 'Indica en qué dirección quieres recibir el equipo solicitado.',
      [STRING_KEYS.shipment.secondaryText]: 'Entrega en Madrid y Barcelona: 48h. Resto de península, Baleares y Canarias: 72h. Excepto festivos.',
      [STRING_KEYS.summary.installation.advice.title]: 'Información adicional:',
      [STRING_KEYS.summary.installation.advice.text[CQ_POTS.INSTALLATION_POT.INSTALLATION_ID]]: 'Un técnico se pondrá en contacto contigo para concertar una cita en la dirección indicada.',
      [STRING_KEYS.summary.installation.advice.text[CQ_POTS.INSTALLATION_POT.AUTO_INSTALLATION_ID]]: '',
      [STRING_KEYS.summary.installation.advice.text[CQ_POTS.INSTALLATION_POT.INSTALLATION_BY_CLIENT]]: '',
    },
    [`mainSelection_${CQ_ACTION_CODES.REGISTER}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.PORTABILITY}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.MIGRATION}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.ACTIVATE_LINE}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.UPGRADE_INCLUDED_LINE}`]: {
    },
  },
  [`user_${USER_TYPE.TELCO}`]: {
    everyMainSelection: {
    },
    [`mainSelection_${CQ_ACTION_CODES.REGISTER}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.PORTABILITY}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.MIGRATION}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.ACTIVATE_LINE}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.UPGRADE_INCLUDED_LINE}`]: {
    },
  },
  [`user_${USER_TYPE.OPEN}`]: {
    everyMainSelection: {
    },
    [`mainSelection_${CQ_ACTION_CODES.REGISTER}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.PORTABILITY}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.MIGRATION}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.ACTIVATE_LINE}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.UPGRADE_INCLUDED_LINE}`]: {
    },
  },
  selfEmployed: {
    everyMainSelection: {
      [STRING_KEYS.se.risk.subject]: 'TELCOBI Equipamiento Riesgo Error 800 AU',
      [STRING_KEYS.se.order.subject]: 'TELCOBI Equipamiento Error TELCO AU',
    },
  },
};
